module.exports = __webpack_public_path__ + "static/media/product_sosguardian.e80ca91c.png";